import React from "react";

function TickIcon4() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <path
        d="M6 12.5C7.5913 12.5 9.11742 11.8679 10.2426 10.7426C11.3679 9.61742 12 8.0913 12 6.5C12 4.9087 11.3679 3.38258 10.2426 2.25736C9.11742 1.13214 7.5913 0.5 6 0.5C4.4087 0.5 2.88258 1.13214 1.75736 2.25736C0.632141 3.38258 0 4.9087 0 6.5C0 8.0913 0.632141 9.61742 1.75736 10.7426C2.88258 11.8679 4.4087 12.5 6 12.5ZM8.64844 5.39844L5.64844 8.39844C5.42812 8.61875 5.07188 8.61875 4.85391 8.39844L3.35391 6.89844C3.13359 6.67812 3.13359 6.32188 3.35391 6.10391C3.57422 5.88594 3.93047 5.88359 4.14844 6.10391L5.25 7.20547L7.85156 4.60156C8.07187 4.38125 8.42812 4.38125 8.64609 4.60156C8.86406 4.82188 8.86641 5.17812 8.64609 5.39609L8.64844 5.39844Z"
        fill="#16A34A"
      />
    </svg>
  );
}

export default TickIcon4;
